
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree7ff"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree7ff"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("k2fvL", function(module, exports) {
// When the search input is focused, add a class to the header.
// This is used to hide some other elements and expand the search bar.
let $e96006cd3b433c6e$var$search = document.querySelector("#search-input");
let $e96006cd3b433c6e$var$header = document.querySelector("header");
$e96006cd3b433c6e$var$search.onfocus = ()=>{
    $e96006cd3b433c6e$var$header.classList.add("search");
};
$e96006cd3b433c6e$var$search.onblur = ()=>{
    $e96006cd3b433c6e$var$header.classList.remove("search");
};
docsearch({
    appId: "BG2BI65LT3",
    apiKey: "6309d86dabd1e4f3de34109753166903",
    indexName: "parceljs",
    inputSelector: "#search-input",
    algoliaOptions: {
        facetFilters: [
            "lang:en",
            "version:v2"
        ]
    }
});
if (typeof visualViewport !== "undefined") visualViewport.addEventListener("resize", ()=>{
    document.documentElement.style.setProperty("--viewport-height", visualViewport.height + "px");
});

});

(function() {
    const replaceElements = document.querySelectorAll("time[datetime].js-replace-date");
    if (replaceElements.length === 0) return;
    const lang = navigator.languages.length ? navigator.languages : document.documentElement.lang;
    const dateFormatter = new Intl.DateTimeFormat(lang, {
        year: "numeric",
        month: "numeric",
        day: "numeric"
    });
    Array.prototype.forEach.call(replaceElements, function(elem) {
        try {
            const date = Date.parse(elem.dateTime + "T00:00:00");
            elem.innerHTML = dateFormatter.format(date);
        } catch (e) {
        // skip
        }
    });
})();


// Mark the current section in the table of contents with aria-current when scrolled into view.
let $826dcaf3978c5d1a$var$tocLinks = document.querySelectorAll('main aside nav a');
let $826dcaf3978c5d1a$var$headers = [];
for (let link of $826dcaf3978c5d1a$var$tocLinks){
    let headerId = link.hash.slice(1);
    let header = document.getElementById(headerId);
    $826dcaf3978c5d1a$var$headers.push({
        link: link,
        header: header
    });
}
function $826dcaf3978c5d1a$var$updateToc() {
    for (let header of $826dcaf3978c5d1a$var$headers)if (header.header.offsetTop + header.header.getBoundingClientRect().height > document.documentElement.scrollTop) {
        let currentSelection = document.querySelector('main aside nav a[aria-current]');
        if (currentSelection) currentSelection.removeAttribute('aria-current');
        header.link.setAttribute('aria-current', 'location');
        break;
    }
}
$826dcaf3978c5d1a$var$updateToc();
document.addEventListener('scroll', ()=>{
    requestAnimationFrame($826dcaf3978c5d1a$var$updateToc);
});


let $0f6b42c0f67c66b8$var$button = document.querySelector('.hamburger-button');
let $0f6b42c0f67c66b8$var$nav = document.querySelector('.docs-navigation');
let $0f6b42c0f67c66b8$var$main = document.querySelector('main');
let $0f6b42c0f67c66b8$var$header = document.querySelector('.parcel-docs-header');
// Hide everything except the button element.
let $0f6b42c0f67c66b8$var$ariaHide = (element, isHidden)=>{
    for (let child of element.children){
        if (!child.contains($0f6b42c0f67c66b8$var$button)) {
            if (isHidden) child.setAttribute('aria-hidden', 'true');
            else child.removeAttribute('aria-hidden');
        } else if (child !== $0f6b42c0f67c66b8$var$button) $0f6b42c0f67c66b8$var$ariaHide(child, isHidden);
    }
};
let $0f6b42c0f67c66b8$var$hide = ()=>{
    $0f6b42c0f67c66b8$var$nav.classList.remove('visible');
    $0f6b42c0f67c66b8$var$main.removeAttribute('aria-hidden');
    $0f6b42c0f67c66b8$var$nav.removeAttribute('tabindex');
    $0f6b42c0f67c66b8$var$button.setAttribute('aria-pressed', 'false');
    $0f6b42c0f67c66b8$var$ariaHide($0f6b42c0f67c66b8$var$header, false);
    if ($0f6b42c0f67c66b8$var$nav.contains(document.activeElement)) $0f6b42c0f67c66b8$var$button.focus();
};
$0f6b42c0f67c66b8$var$button.onclick = ()=>{
    $0f6b42c0f67c66b8$var$nav.classList.toggle('visible');
    if ($0f6b42c0f67c66b8$var$nav.classList.contains('visible')) {
        $0f6b42c0f67c66b8$var$main.setAttribute('aria-hidden', 'true');
        $0f6b42c0f67c66b8$var$button.setAttribute('aria-pressed', 'true');
        $0f6b42c0f67c66b8$var$ariaHide($0f6b42c0f67c66b8$var$header, true);
        $0f6b42c0f67c66b8$var$nav.tabIndex = -1;
        $0f6b42c0f67c66b8$var$nav.focus();
    } else $0f6b42c0f67c66b8$var$hide();
};
document.body.onclick = (e)=>{
    if (!$0f6b42c0f67c66b8$var$nav.contains(e.target) && !$0f6b42c0f67c66b8$var$button.contains(e.target)) $0f6b42c0f67c66b8$var$hide();
};
$0f6b42c0f67c66b8$var$nav.onkeydown = (e)=>{
    if (e.key === 'Escape') $0f6b42c0f67c66b8$var$hide();
    // Trap focus when nav is open.
    if (e.key === 'Tab' && $0f6b42c0f67c66b8$var$nav.classList.contains('visible')) {
        let tabbables = $0f6b42c0f67c66b8$var$nav.querySelectorAll('button, a[href]');
        let first = tabbables[0];
        let last = tabbables[tabbables.length - 1];
        if (event.shiftKey && event.target === first) {
            event.preventDefault();
            last.focus();
        } else if (!event.shiftKey && event.target === last) {
            event.preventDefault();
            first.focus();
        }
    }
};
let $0f6b42c0f67c66b8$var$mq = window.matchMedia('(max-width: 1024px)');
$0f6b42c0f67c66b8$var$mq.addListener((e)=>{
    if (!e.matches) $0f6b42c0f67c66b8$var$hide();
});


let $decdbef0928886ed$var$toggle = document.querySelector("#color-scheme-toggle");
$decdbef0928886ed$var$toggle.onclick = ()=>{
    isDarkMode = !isDarkMode;
    sessionStorage.setItem("isDarkMode", isDarkMode);
    updateMode(isDarkMode);
};
document.documentElement.classList.add('loaded');


parcelRequire("k2fvL");
// Code examples written in multiple languages are rendered as tabs (see the
// codetabs shortcode), and API names in prose have a variant for each language
// (see the api shortcode). Selecting a language updates the whole page, and is
// remembered across pages. code-tabs-init.js applies the stored language before
// the page renders to avoid a flash of the default language.
const $4c1716afd88d1cfe$var$STORAGE_KEY = "codeLanguage";
function $4c1716afd88d1cfe$var$selectLanguage(lang) {
    document.documentElement.dataset.codeLanguage = lang;
    for (let group of document.querySelectorAll(".code-tabs, .api-name")){
        let langs = group.dataset.langs.split(" ");
        let selected = langs.includes(lang) ? lang : langs[0];
        for (let tab of group.querySelectorAll("[role=tab]")){
            let isSelected = tab.dataset.lang === selected;
            tab.setAttribute("aria-selected", String(isSelected));
            tab.tabIndex = isSelected ? 0 : -1;
        }
        for (let variant of group.children)if (variant.dataset.lang) variant.hidden = variant.dataset.lang !== selected;
    }
}
function $4c1716afd88d1cfe$var$activate(tab) {
    let lang = tab.dataset.lang;
    try {
        localStorage.setItem($4c1716afd88d1cfe$var$STORAGE_KEY, lang);
    } catch  {}
    // Switching languages changes the height of examples above this one,
    // so keep the selected tab in the same place on screen.
    let top = tab.getBoundingClientRect().top;
    $4c1716afd88d1cfe$var$selectLanguage(lang);
    window.scrollBy(0, tab.getBoundingClientRect().top - top);
}
document.addEventListener("click", (e)=>{
    let tab = e.target.closest(".code-tabs [role=tab]");
    if (tab) $4c1716afd88d1cfe$var$activate(tab);
});
document.addEventListener("keydown", (e)=>{
    let tab = e.target.closest(".code-tabs [role=tab]");
    if (!tab) return;
    let tabs = [
        ...tab.parentElement.querySelectorAll("[role=tab]")
    ];
    let index = tabs.indexOf(tab);
    let next;
    switch(e.key){
        case "ArrowLeft":
            next = tabs[(index - 1 + tabs.length) % tabs.length];
            break;
        case "ArrowRight":
            next = tabs[(index + 1) % tabs.length];
            break;
        case "Home":
            next = tabs[0];
            break;
        case "End":
            next = tabs[tabs.length - 1];
            break;
        default:
            return;
    }
    e.preventDefault();
    $4c1716afd88d1cfe$var$activate(next);
    next.focus();
});
// Keep other open pages in sync.
window.addEventListener("storage", (e)=>{
    if (e.key === $4c1716afd88d1cfe$var$STORAGE_KEY && e.newValue) $4c1716afd88d1cfe$var$selectLanguage(e.newValue);
});
let $4c1716afd88d1cfe$var$lang = document.documentElement.dataset.codeLanguage;
if ($4c1716afd88d1cfe$var$lang) $4c1716afd88d1cfe$var$selectLanguage($4c1716afd88d1cfe$var$lang);




//# sourceMappingURL=404.792beef1.js.map
